<template>
  <q-select
    ref="select"
    v-model="terms"
    v-bind="$attrs"
    :class="{ required: $attrs.required }"
    dense
    outlined
    clearable
    use-input
    emit-value
    map-options
    options-dense
    fill-input
    hide-selected
    hide-bottom-space
    :options="localOptions"
    :label="getLabel"
    :error="$attrs.error"
    :error-message="$attrs.errorMessage"
    :disable="$attrs.disable"
    :readonly="$attrs.readonly"
    @filter="search"
  >
    <template v-slot:after>
      <slot name="after"> </slot>
    </template>
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
        <q-item-section>
          <q-item-label v-html="scope.opt.label" />
          <q-item-label caption>{{ scope.opt.sublabel }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          {{ $t('Common.NoResult.Text') }}
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>
<script>
export default {
  inheritAttrs: false,
  name: 'QSelectCustom',
  props: {
    value: {},
    selectDefault: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Object,
    },
  },
  data: () => ({
    terms: '',
    localOptions: [],
  }),
  watch: {
    '$attrs.options': {
      handler(to) {
        this.localOptions = [...to]
        this.terms =
          this.selectDefault && !this.value ? this.$helpers.getValue(this.localOptions, '[0].value', null) : this.value
      },
      deep: true,
    },
    terms: {
      handler(to) {
        this.$emit('input', to)
        this.$emit('callback')
      },
    },
    selected: {
      handler(to) {
        this.localOptions.push(to)
        this.terms = to.value || null
      },
      deep: true,
    },
  },
  computed: {
    getLabel() {
      return this.$attrs.label || this.$ts('labels.search')
    },
  },
  methods: {
    async search(terms, update) {
      terms = terms.toLowerCase()
      let filterOptions = [...this.$attrs.options]
      if (this.selected) {
        filterOptions = [...[this.selected]]
      }
      if (terms !== '') {
        update(() => {
          this.localOptions = filterOptions.filter(x => {
            let label = x.label.toLowerCase()
            return label.includes(terms)
          })
        })
      } else {
        update(() => {
          this.localOptions = filterOptions
        })
      }
    },
  },
}
</script>
